import { render, staticRenderFns } from "./StSystemNavigationDrawer.vue?vue&type=template&id=3ed74473&scoped=true&"
import script from "./StSystemNavigationDrawer.vue?vue&type=script&lang=js&"
export * from "./StSystemNavigationDrawer.vue?vue&type=script&lang=js&"
import style0 from "./StSystemNavigationDrawer.vue?vue&type=style&index=0&id=3ed74473&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ed74473",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VNavigationDrawer } from 'vuetify/lib/components/VNavigationDrawer';
installComponents(component, {VNavigationDrawer})


/* hot reload */
if (module.hot) {
  var api = require("/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3ed74473')) {
      api.createRecord('3ed74473', component.options)
    } else {
      api.reload('3ed74473', component.options)
    }
    module.hot.accept("./StSystemNavigationDrawer.vue?vue&type=template&id=3ed74473&scoped=true&", function () {
      api.rerender('3ed74473', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/base/StSystemNavigationDrawer.vue"
export default component.exports